import { Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "../pages/dashboard/Dashboard";
import Client from "../pages/client/Client";
import Companies from "../pages/company/Companies";
import Formula from "../pages/formula/Formula";
import History from "../pages/history/History";
import ClientDetail from "../pages/client/ClientDetail";
import SelectedPayroll from "../pages/payroll/SelectedPayroll";
import TaxView from "../pages/payroll/TaxView";
import DDPaidSuccessfully from "../pages/payroll/DDPaidSuccessfuly";
import CompanyDetailPage from "../pages/company/CompanyDetailPage";
import AddNewClint from "../pages/client/AddNewClint";
import AddNewFormula from "../pages/formula/AddNewFormula";
import ClintAddedSuccessfuly from "../pages/client/ClintAddedSuccessfuly";
import SuccessPage from "../components/SuccessPage";
import EditClient from "../pages/client/EditClient";
import Employes from "../pages/employee/Employes";
import EmployePayroll from "../pages/payroll/EmployeePayroll";
import PersonalDetails from "../pages/employee/PersonalDetails";
import Login from "../pages/auth/Login";
import ForgotPassword from "../pages/auth/ForgotPassword";
import ChangePassword from "../pages/auth/ChangePassword";
import AddNewCompany from "../pages/company/AddNewCompany";
import EditCompany from "../pages/company/EditCompany";
import AddNewEmployee from "../pages/employee/AddNewEmployee";
import EditEmployee from "../pages/employee/EditEmployee";
import ProfilePage from "../pages/profile/ProfilePage";
import Notifications from "../components/notification/Notifications";
import ResetPassword from "../pages/auth/ResetPassword";
import PendingPayrollPayments from "../pages/payroll/PendingPayrollPayments";
import ProtectedRoute from "./ProtectedRoute";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes - No authentication required */}
      <Route
        path="/"
        element={
          <ProtectedRoute isPublic={true}>
            <Login />
          </ProtectedRoute>
        }
      />
      <Route
        path="/login"
        element={
          <ProtectedRoute isPublic={true}>
            <Login />
          </ProtectedRoute>
        }
      />
      <Route
        path="/forgotpassword"
        element={
          <ProtectedRoute isPublic={true}>
            <ForgotPassword />
          </ProtectedRoute>
        }
      />
      <Route
        path="/resetpassword"
        element={
          <ProtectedRoute isPublic={true}>
            <ResetPassword />
          </ProtectedRoute>
        }
      />

      {/* Protected Routes - Authentication required */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Dashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/client"
        element={
          <ProtectedRoute>
            <Client />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clientdetail/:id"
        element={
          <ProtectedRoute>
            <ClientDetail />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editclient/:id?"
        element={
          <ProtectedRoute>
            <EditClient />
          </ProtectedRoute>
        }
      />

      <Route
        path="/companies"
        element={
          <ProtectedRoute>
            <Companies />
          </ProtectedRoute>
        }
      />
      <Route
        path="/addcompany"
        element={
          <ProtectedRoute>
            <AddNewCompany />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editcompany"
        element={
          <ProtectedRoute>
            <EditCompany />
          </ProtectedRoute>
        }
      />
      <Route
        path="/companydetailpage/:id?"
        element={
          <ProtectedRoute>
            <CompanyDetailPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/employes"
        element={
          <ProtectedRoute>
            <Employes />
          </ProtectedRoute>
        }
      />
      <Route
        path="/addnewemployee"
        element={
          <ProtectedRoute>
            <AddNewEmployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/editemployee"
        element={
          <ProtectedRoute>
            <EditEmployee />
          </ProtectedRoute>
        }
      />
      <Route
        path="/employepayroll/:id?"
        element={
          <ProtectedRoute>
            <EmployePayroll />
          </ProtectedRoute>
        }
      />
      <Route
        path="/personaldetails/:id?"
        element={
          <ProtectedRoute>
            <PersonalDetails />
          </ProtectedRoute>
        }
      />

      <Route
        path="/formula"
        element={
          <ProtectedRoute>
            <Formula />
          </ProtectedRoute>
        }
      />
      <Route
        path="/history"
        element={
          <ProtectedRoute>
            <History />
          </ProtectedRoute>
        }
      />

      <Route
        path="/addnewclient"
        element={
          <ProtectedRoute>
            <AddNewClint />
          </ProtectedRoute>
        }
      />
      <Route
        path="/addnewformula"
        element={
          <ProtectedRoute>
            <AddNewFormula />
          </ProtectedRoute>
        }
      />
      <Route
        path="/clintaddedsuccessfuly"
        element={
          <ProtectedRoute>
            <ClintAddedSuccessfuly />
          </ProtectedRoute>
        }
      />
      <Route
        path="/successPage"
        element={
          <ProtectedRoute>
            <SuccessPage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/profilePage"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />

      <Route
        path="/selectedpayroll/:id?"
        element={
          <ProtectedRoute>
            <SelectedPayroll />
          </ProtectedRoute>
        }
      />
      <Route
        path="/taxview"
        element={
          <ProtectedRoute>
            <TaxView />
          </ProtectedRoute>
        }
      />
      <Route
        path="/ddpaidsuccessfully"
        element={
          <ProtectedRoute>
            <DDPaidSuccessfully />
          </ProtectedRoute>
        }
      />

      <Route
        path="/notifications"
        element={
          <ProtectedRoute>
            <Notifications />
          </ProtectedRoute>
        }
      />

      <Route
        path="/changepassword"
        element={
          <ProtectedRoute>
            <ChangePassword />
          </ProtectedRoute>
        }
      />
      <Route
        path="/pendingpayments/:id"
        element={
          <ProtectedRoute>
            <PendingPayrollPayments />
          </ProtectedRoute>
        }
      />

      {/* Catch all - redirect to dashboard or login */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default AppRoutes;
